export default __webpack_public_path__ + "static/media/default_logo.05ed3d0d.png";